import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodImporter  {
    _originalTypeClassName = "zERP.BO.GoodImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodImporter.translate = translateService;
}
this.GoodImporterKey = null;
this._key = this.GoodImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _GoodImporterKey:any;
get GoodImporterKey(): any {
    return this._GoodImporterKey;
  }
set GoodImporterKey(value: any) {
    this._GoodImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GoodImporterKey == null || $this.GoodImporterKey == 0;
            }


}